module.exports = __webpack_public_path__ + "static/media/adminRole.b4b35c59.svg";